// extracted by mini-css-extract-plugin
module.exports = {"linkArrow":"dateFinderMob_linkArrow__1LB5M","arrow":"dateFinderMob_arrow__2RGp-"};